export enum ListingType {
    OFFERS,
    PROPERTIES
}
export enum ListingType {
    OFFERS,
    PROPERTIES
}
